import { render, staticRenderFns } from "./CustomViewTabFrames.vue?vue&type=template&id=4371cdc7&scoped=true"
import script from "./CustomViewTabFrames.vue?vue&type=script&lang=ts"
export * from "./CustomViewTabFrames.vue?vue&type=script&lang=ts"
import style0 from "./CustomViewTabFrames.vue?vue&type=style&index=0&id=4371cdc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4371cdc7",
  null
  
)

export default component.exports